/**
 * The phone app's words for its lists, views and search (piece 35, *Lists,
 * views and search (batch CR8)*; decision 4410): what the phone says about a
 * list's next page, its sort panel and the one search box on Home that the web
 * does not already say. Spread into the one string lookup beside the earlier
 * batches' words. A word the web already says, such as Sorted by, A to Z, Tags,
 * Any, Clear All, Quick views or Searching, is read from the web's own key and
 * is not repeated here.
 */
export const CRM_LISTS_STRINGS = {
  'mobile.lists.moreFailed': 'The next page did not load.',
  'mobile.lists.sortBy': 'Sort by',
  'mobile.lists.direction': 'Order',
  'mobile.lists.tagsCleared': 'Clear Tags',
  'mobile.search.label': 'Search Companies, People, Locations and Deals',
  'mobile.search.placeholder': 'Search companies, people, places, deals',
  'mobile.search.tooShort': 'Type two letters or more to search.',
  'mobile.search.matchedIn': 'Found in',
} as const;
